import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { DeleteStatus, ItemMode, ListServiceCardStatus, ListUserType, MasterDataStatus, ServiceCardStatus, SharedService, UserType } from '../../shared/shared.service';;
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { distinctUntilChanged } from 'rxjs';
import moment from 'moment';
import { ProxyDynamicService } from '../../shared/service/proxy-dynamic.service';
import { TranslateService } from '@ngx-translate/core';
import { NzNotificationService } from "ng-zorro-antd/notification";

@Component({
  selector: 'app-service-card-item',
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss'
})
export class ItemComponent implements OnInit, AfterViewInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  formGroup!: FormGroup;
  itemMode = ItemMode;
  mode = ItemMode.Add;
  DeleteStatus = DeleteStatus
  data: any = {};
  detailCard: any = {};
  curentDate = moment().endOf('day').toDate();

  listUserType = ListUserType
  listServiceCardStatus = ListServiceCardStatus.filter((item: any) => item.value !== ServiceCardStatus.Deleted)
  status = ServiceCardStatus;

  listOwnerByUser: any[] = [];
  listApartment: any[] = [];
  listApartmentByOwner: any[] = [];
  errorApartment: string = '';
  isOwner: boolean = true;
  cancelSearchOwner = false;
  keywordOwner = '';

  get f() {
    return this.formGroup.controls;
  }

  constructor(
    private modal: NzModalRef,
    private fb: FormBuilder,
    private sharedService: SharedService,
    private service: ProxyDynamicService,
    private translate: TranslateService,
    private noti: NzNotificationService
  ) {
    this.mode = this.nzModalData.mode;
    if (this.nzModalData.data) {
      this.data = JSON.parse(JSON.stringify(this.nzModalData.data));
    }
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      id: [null],
      activated_date: [null, Validators.required],
      card_no: [null, Validators.required],
      user_type: [null, Validators.required],
      owner: [null, Validators.required],
      apartment_ids: [null, Validators.required],
      note: [null],
      status: [ServiceCardStatus.Active, Validators.required],
    });
  }

  ngAfterViewInit(): void {
    if (this.mode === ItemMode.Add) {
      this.f['activated_date'].setValue(this.curentDate, { emitEvent: false });
      this.f['status'].disable();
    }

    if (this.mode === ItemMode.Edit) {
      this.f['card_no'].disable();
      this.f['user_type'].disable();
      this.f['owner'].disable();
      this.f['apartment_ids'].disable();
      this.getCardInfo();
    }

    if (this.mode === ItemMode.View) {
      this.service.getDetailCard(this.data.card_id).subscribe((res) => {
        this.detailCard = res.data;
      });
    }

    this.f['user_type'].valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      this.listOwnerByUser = [];
      this.f['owner'].setValue(null, { emitEvent: false });
      this.f['apartment_ids'].setValue(null, { emitEvent: false });
      this.listApartment = [];
      this.isOwner = value === UserType.Owner;
    });

    // this.f['apartment_ids'].valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
    //   // this.errorApartment = '';
    //   // const validators = [Validators.required];
    //   if (!value || value.length === 0) {
    //     this.listApartment = [...this.listApartmentByOwner];
    //   } 
    // else {
    //   const apartmentSelected = this.listApartmentByOwner.find((item: any) => item.id === value[0]);
    //   if (apartmentSelected) {
    //     if (apartmentSelected.operation_type === OperationType.OwnerManaged) {
    //       this.listApartment = this.listApartmentByOwner.filter((item: any) => item.operation_type === OperationType.OwnerManaged);
    //       if (value.length > 1) {
    //         validators.push(Validators.maxLength(1));
    //         this.errorApartment = this.translate.instant('service-card.error-choose-apartment');
    //       }
    //     } else if (apartmentSelected.operation_type === OperationType.SelfManaged) {
    //       this.listApartment = this.listApartmentByOwner.filter((item: any) => item.operation_type === OperationType.SelfManaged);
    //     }
    //   }
    // }
    // this.f['apartment_ids'].setValidators(validators);
    // this.f['apartment_ids'].updateValueAndValidity();
    // });

    this.f['owner'].valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      this.f['apartment_ids'].setValue(null, { emitEvent: false });
      if (value) {
        this.getDataApartment();
      } else {
        this.listApartment = [];
      }
    });
  }

  getCardInfo() {
    this.service.findById('service_card', this.data?.card_id, {
      fields: ['*', 'owner_id.id', 'owner_id.code', 'butler_id.id', 'butler_id.code',
        'apartment_ids.apartment_id.*', 'apartment_ids.deleted']
    }).then(res => {
      if (res) {
        this.f['id'].setValue(res['id']);
        this.f['activated_date'].setValue(moment(res['activated_date']).utc(true).toDate());
        this.f['card_no'].setValue(res['card_no']);
        this.f['note'].setValue(res['note']);
        this.f['status'].setValue(res['status']);

        if (res['owner_id']) {
          this.f['user_type'].setValue(UserType.Owner);
          this.f['owner'].setValue(res['owner_id']['id']);
          this.keywordOwner = res['owner_id']['code']?.toString() ?? '';
          this.filterDataOwner(this.keywordOwner);
        }

        if (res['butler_id']) {
          this.f['user_type'].setValue(UserType.Butler);
          this.f['owner'].setValue(res['butler_id']['id']);
          this.keywordOwner = res['butler_id']['code']?.toString() ?? '';
          this.filterDataButler(this.keywordOwner);
        }

        if (res['apartment_ids']) {
          const listApartmentByCard = res['apartment_ids'].filter((item: any) => item.deleted === DeleteStatus.NO)
            .map((item: any) => item.apartment_id)
            .map((item: any) => item.id);
          this.f['apartment_ids'].setValue(listApartmentByCard, { emitEvent: false });
        }
      }
    }, (error) => {
      this.service.handleError(error)
    })
  }

  edit() {
    this.getCardInfo();
    this.mode = ItemMode.Edit;
    this.f['card_no'].disable();
    this.f['user_type'].disable();
    this.f['owner'].disable();
    this.f['apartment_ids'].disable();
  }

  destroyModal() {
    this.modal.destroy()
  }

  onSave() {
    if (this.formGroup.valid) {
      if (this.f['status'].value === ServiceCardStatus.Block && (!!Number(this.data.total_balance) || !!Number(this.data.total_service))) {
        this.noti.create('error', '', this.translate.instant('service-card.error-lock-card'));
        return;
      }
      this.sharedService.showLoading(true);
      const body = this.formGroup.getRawValue();
      if (body.user_type === UserType.Owner) {
        body.owner_id = body.owner;
      }
      else {
        body.butler_id = body.owner
      }
      body.owner = undefined;
      body.activated_date = moment(body.activated_date).utc(true).format('YYYY-MM-DD');

      if (this.mode === ItemMode.Add) {
        body.id = undefined
        this.service.createCard(body).subscribe(() => {
          this.sharedService.showLoading(false);
          this.modal.destroy(true);
        }, (error: any) => {
          this.service.handleError(error)
        });
      }
      if (this.mode === ItemMode.Edit) {
        this.service.updateCard(this.data.card_id, body).subscribe(() => {
          this.sharedService.showLoading(false);
          this.modal.destroy(true);
        }, (error: any) => {
          this.service.handleError(error)
        });
      }
    } else {
      this.sharedService.showLoading(false);
      Object.values(this.formGroup.controls).forEach(control => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  getMoreDataOwner(event: any) {
    if (!this.cancelSearchOwner) {
      const query = !!this.keywordOwner ? {
        '_or': [{ 'name': { '_icontains': this.keywordOwner } }, { 'code': { '_icontains': this.keywordOwner } }, { 'phone': { '_icontains': this.keywordOwner } }],
        'status': { '_eq': MasterDataStatus.Active },
        'deleted': { '_eq': DeleteStatus.NO }
      } : { 'status': { '_eq': MasterDataStatus.Active }, 'deleted': { '_eq': DeleteStatus.NO } }
      this.service.searchWithMeta('owner', {
        filter: query,
        limit: 100,
        page: !event ? 0 : Math.round(this.listOwnerByUser.length / 100),
      }).then((res: any) => {
        if (!event && !!this.keywordOwner) {
          this.listOwnerByUser = res.data.map((item: any) => {
            item['text'] = item.code + ' - ' + item.name + (item.phone ? ' - ' + item.phone : '');
            item['value'] = item.id;
            return item;
          });
        } else {
          this.listOwnerByUser = this.listOwnerByUser.concat(res.data.map((item: any) => {
            item['text'] = item.code + ' - ' + item.name + (item.phone ? ' - ' + item.phone : '');
            item['value'] = item.id;
            return item;
          }));
        }
        this.cancelSearchOwner = this.listOwnerByUser.length === Number(res.total);
      })
    }
  }

  filterDataOwner(event: any) {
    this.keywordOwner = event;
    this.cancelSearchOwner = false;
    if (event) {
      this.getMoreDataOwner(false);
    } else {
      this.listOwnerByUser = []
    }
  }

  getMoreDataButler(event: any) {
    if (!this.cancelSearchOwner) {
      const query = !!this.keywordOwner ? {
        '_or': [{ 'name': { '_icontains': this.keywordOwner } }, { 'code': { '_icontains': this.keywordOwner } }, { 'phone': { '_icontains': this.keywordOwner } }],
        'status': { '_eq': MasterDataStatus.Active },
        'deleted': { '_eq': DeleteStatus.NO }
      } : { 'status': { '_eq': MasterDataStatus.Active }, 'deleted': { '_eq': DeleteStatus.NO } }
      this.service.searchWithMeta('butler', {
        filter: query,
        limit: 100,
        page: !event ? 0 : Math.round(this.listOwnerByUser.length / 100),
      }).then((res: any) => {
        if (!event && !!this.keywordOwner) {
          this.listOwnerByUser = res.data.map((item: any) => {
            item['text'] = item.code + ' - ' + item.name + (item.phone ? ' - ' + item.phone : '');
            item['value'] = item.id;
            return item;
          });
        } else {
          this.listOwnerByUser = this.listOwnerByUser.concat(res.data.map((item: any) => {
            item['text'] = item.code + ' - ' + item.name + (item.phone ? ' - ' + item.phone : '');
            item['value'] = item.id;
            return item;
          }));
        }
        this.cancelSearchOwner = this.listOwnerByUser.length === Number(res.total);
      })
    }
  }

  filterDataButler(event: any) {
    this.keywordOwner = event;
    this.cancelSearchOwner = false;
    if (event) {
      this.getMoreDataButler(false);
    } else {
      this.listOwnerByUser = []
    }
  }

  getDataApartment() {
    let query = {
      'status': { '_eq': MasterDataStatus.Active }, 'deleted': { '_eq': DeleteStatus.NO },
      ...(this.f['user_type'].value === UserType.Owner ? { 'owner': { '_eq': this.f['owner'].value } } : { 'butler_id': { '_eq': this.f['owner'].value } })
    }
    this.service.search('apartment', {
      filter: query,
    }).then((res: any) => {
      this.listApartmentByOwner = res.map((item: any) => {
        item['text'] = item.code;
        item['value'] = item.id;
        return item;
      });
      this.listApartment = this.listApartmentByOwner;
    })
  }
}
